import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Popover,
  Typography,
  FormControl,
  select,
  MenuItem,
  Checkbox,
  ListItemText,
  Select,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import eOpsLogo from "../../../images/eops.png";
import excel from "../../../images/excel.png";
import mepcoLogo from "../../../images/mepcoLogo.png";
import pdf from "../../../images/pdf.png";
import print from "../../../images/print.png";
import { cfpBaseUrl } from "../../../network/urls";
import {
  // convertDate,
  convertDatewithTime,
  printStamp,
  subdivisionName,
  getName,
  getShortMonthName,
  companyShortName,
  getCompanyName,
  companyName,
  getLogo,
} from "../../../services/Functions";
import { internalIconStyles } from "../../../style/common";
import "../../../style/common.scss";
import { Code } from "lucide-react";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

const TopBestAndWorstPerformer = () => {
  const getCurrentMonthFirstDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}-01`;
  };
  const {
    token,
    code,
    name,
    roleName,
    roleTypeName,
    cscID,
    cfcLevelId,
    roleId,
    hierarchy: userHierarchy,
  } = useSelector((state) => state.auth);
  const offCode =
    userHierarchy == 1
      ? code
      : userHierarchy == 2
        ? code.slice(0, 2)
        : userHierarchy == 3
          ? code.slice(0, 3)
          : userHierarchy == 4
            ? code.slice(0, 4)
            : userHierarchy == 5
              ? code.slice(0, 5)
              : code;
  const [isLoading, setIsLoading] = React.useState(false);
  // const { officeCode: offCode } = useSelector(state => state.officeCode);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || [],
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");
  const [totals, setTotals] = useState({});
  const [dateFrom, setDateFrom] = useState(getCurrentMonthFirstDate());
  const [dateTo, setDateTo] = useState(getCurrentMonthFirstDate());
  const tableRef = useRef(null);
  const [dateFromDisplay, setDateFromDisplay] = useState("");
  const [dateToDisplay, setDateToDisplay] = useState("");
  const [category, setCategory] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [anchorElOPI, setAnchorElOPI] = useState(null);
  const [anchorElTHT, setAnchorElTHT] = useState(null);
  const [apiData, setApiData] = useState([]);
  const [circleCode, setCircleCode] = useState("");
  const [circleName, setCircleName] = useState("");
  const [officeCode, setOfficeCode] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [uniqueRoles, setUniqueRoles] = useState([]);
  const [excludedRoles, setExcludedRoles] = useState([]);
  const [recordsNeeded, setRecordsNeeded] = useState(5);
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const [hierarchy, setHierarchy] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRemarks, setSelectedRemarks] = useState("");
  const [selectedPerson, setSelectedPerson] = useState("");
  const [lastModifiedByOptions, setLastModifiedByOptions] = useState([]);
  const [selectedPerson1, setSelectedPerson1] = useState("");
  const [registeredByOptions, setRegisteredByOptions] = useState([]);
  const [desginationCodeToApi, setDesginationCodeToApi] = useState("1135");
  const [desginationList, setDesginationList] = useState([]);
  const [companyCode, setCompanyCode] = useState("15");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const convertDate = (dateString) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return ''; // or 'Invalid Date' — handle invalid input

    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${month}-${year}`;
  };
  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  const recordOptions = Array.from({ length: 20 }, (_, i) => (i + 1) * 5);

  useEffect(() => {
    setOfficeCode(circleCode);
  }, [circleCode]);

  useEffect(() => {
    if (tableData?.length > 0) {
      const roles = [
        ...new Set(
          tableData.map((item) => item.roleName?.trim()).filter(Boolean), // remove empty/undefined
        ),
      ].sort(); // optional: alphabetical order

      setUniqueRoles(roles);
    } else {
      setUniqueRoles([]);
    }
  }, [tableData]);

  const getFilteredAndSortedData = () => {
    let data = tableData || [];

    // 1. Exclude selected roles
    if (excludedRoles.length > 0) {
      data = data.filter(
        (item) => !excludedRoles.includes(item.roleName?.trim() || ""),
      );
    }

    // 2. Sort
    const activeSortField = sortField || "totalResolved"; // fallback
    const activeSortOrder = sortOrder || "desc";

    return [...data].sort((a, b) => {
      let aValue, bValue;

      if (activeSortField === "totalHandlingTime") {
        aValue =
          (Number(a.avgTimeTakenResolved) || 0) +
          (Number(a.avgTimeTakenOnhold) || 0);
        bValue =
          (Number(b.avgTimeTakenResolved) || 0) +
          (Number(b.avgTimeTakenOnhold) || 0);
      } else if (activeSortField === "OPI") {
        // ← add this branch
        aValue = Number(a.OPI) || 0;
        bValue = Number(b.OPI) || 0;
      } else {
        aValue = Number(a[activeSortField]) || 0;
        bValue = Number(b[activeSortField]) || 0;
      }

      // Apply sort direction
      if (activeSortOrder === "asc") {
        return aValue - bValue;
      } else {
        return bValue - aValue;
      }
    });
  };

  // Check if excluding the clicked role would remove all remaining roles
  const wouldExcludeAll = (roleToToggle) => {
    const newExcluded = excludedRoles.includes(roleToToggle)
      ? excludedRoles.filter((r) => r !== roleToToggle) // unchecking
      : [...excludedRoles, roleToToggle]; // checking

    // If after toggle there are no remaining roles → not allowed
    return newExcluded.length === uniqueRoles.length;
  };

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions,
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              console.error("Error fetching subDivisions:", result.message);
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching subDivisions:", error);
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode,
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode,
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode,
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode,
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(offCode == 10 ? 15 : offCode);
          let officeName = getName(
            offCode == 10 ? "15" : offCode.toString(),
            subDivisions,
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode,
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode,
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode,
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode,
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode,
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode,
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions,
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode),
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode,
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode,
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions,
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(offCode == 10 ? 15 : offCode);
        let offName = getName(
          offCode == 10 ? "15" : offCode.toString(),
          subDivisions,
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            setOfficeCode(15);
            setOfficeName("PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        console.log("1 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        console.log("2 wala if");
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        console.log("3 wala if");
        setCircleCode(offCode.slice(0, 3));
        console.log(offCode.slice(0, 3), "djlsahjdhalhdalhlkd");
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode,
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        console.log("4 wala if");
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  const getStats = async (officeCode, dateFrom, dateTo) => {
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", "");
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        officeCode: officeCode,
        dateFrom: dateFrom,
        dateTo: dateFrom,
      });
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl +
        "lineComplaints/topFieldStaffBestAndWorstPerformersForEops",
        requestOptions,
      );
      const result = await response.json();

      if (result.status == "200") {
        const data = result.data;

        setTableData(data);
      } else if (result.status == "400") {
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching stats:", error);
      setTableData([]);
    }
    setViewBackdrop(false);
  };

  const exportToExcel = () => {
    const wb = XLSX.utils.table_to_book(tableRef.current, {
      sheet: "Sheet1",
    });

    const wbout = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    const filename = `Top ${sortOrder === "asc" ? "Worst" : "Best"} Performer${sortPart} - ${officeName} - ${convertDate(dateFrom)}.xlsx`;

    saveAs(new Blob([wbout]), filename);
  };

  const connectionTypes = [
    "Sr No.",
    "Subdivision",
    "Employee",
    "User Id",
    "Role",
    "Tot. Cmplnt.",
    "Total In Progress",
    "In Progress Within Time",
    "In Progress Late",
    "Tot. Rslvd.",
    "Resolved in Time",
    "Resolved Late",
    "THT",
    "OPI",
  ];

  //   const DownloadPdf = async (print) => {
  //   return new Promise((resolve, reject) => {
  //     let offName = subdivisionName(parseInt(code), subDivisions);
  //     let dateToPrint = convertDate(new Date());
  //     let stampData = printStamp(code, offName, name, roleName, dateToPrint);
  //     const title =
  //     dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
  //       ? `Top ${sortOrder === "asc" ? "Best" : "Worst"} Performer${sortPart} Field Staff Report for ${officeName} of ${convertDate(dateFrom)}`
  //       : `Top ${sortOrder === "asc" ? "Best" : "Worst"} Performer${sortPart} Field Staff Report for ${officeName} from ${
  //           dateFrom ? convertDate(dateFrom) : "-"
  //         } to ${dateTo ? convertDate(dateTo) : "-"}`;

  //     const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();
  //     const logoWidth = ["12", "13", "11", "16", "27", "48", "59"].includes(
  //       companyCode,
  //     )
  //       ? 25
  //       : 30;
  //     const logoHeight = ["12", "13", "11", "16", "27", "48", "59"].includes(
  //       companyCode,
  //     )
  //       ? 20
  //       : 10;
  //     pdf.addImage(
  //       getLogo(code.slice(0, 2)),
  //       "PNG",
  //       15,
  //       5,
  //       logoWidth,
  //       logoHeight,
  //     );

  //     const eOpsLogoWidth = 20;
  //     const eOpsLogoHeight = 8;
  //     const eOpsLogoXPosition = [
  //       "12",
  //       "13",
  //       "11",
  //       "16",
  //       "27",
  //       "48",
  //       "59",
  //     ].includes(companyCode)
  //       ? 43
  //       : 17;
  //     pdf.addImage(
  //       eOpsLogo,
  //       "PNG",
  //       eOpsLogoXPosition,
  //       ["12", "13", "11", "16", "27", "48", "59"].includes(companyCode)
  //         ? 12
  //         : 17,
  //       eOpsLogoWidth,
  //       eOpsLogoHeight,
  //     );

  //     pdf.setFontSize(12);
  //     pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
  //       align: "center",
  //     });
  //     pdf.text(
  //       `Top ${
  //         sortOrder == "asc" ? "Best" : "Worst"
  //       } Performer Field Staff Report for ${officeName}`,
  //       pageWidth / 2,
  //       18,
  //       { align: "center" },
  //     );
  //     pdf.setFontSize(10);
  //     pdf.text(title, pageWidth / 2, 25, { align: "center" });
  //     pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
  //     pdf.text("Name: " + name, pageWidth - 65, 17);
  //     pdf.text("Designation: " + roleName, pageWidth - 65, 22);

  //     // Create two-row header structure
  //     const headers = [
  //       [
  //         // First row - main headers with rowspan and colspan
  //         {
  //           content: "Sr#",
  //           rowSpan: 2,
  //           styles: { halign: "center", valign: "middle", fontStyle: "bold" },
  //         },
  //         {
  //           content: "Subdivision",
  //           rowSpan: 2,
  //           styles: { halign: "center", valign: "middle", fontStyle: "bold" },
  //         },
  //         {
  //           content: "Employee",
  //           rowSpan: 2,
  //           styles: { halign: "center", valign: "middle", fontStyle: "bold" },
  //         },
  //         {
  //           content: "User ID",
  //           rowSpan: 2,
  //           styles: { halign: "center", valign: "middle", fontStyle: "bold" },
  //         },
  //         {
  //           content: "Role",
  //           rowSpan: 2,
  //           styles: { halign: "center", valign: "middle", fontStyle: "bold" },
  //         },
  //         {
  //           content: "Total Complaints",
  //           rowSpan: 2,
  //           styles: { halign: "center", valign: "middle", fontStyle: "bold" },
  //         },
  //         {
  //           content: "In Progress",
  //           colSpan: 3,
  //           styles: { halign: "center", valign: "middle", fontStyle: "bold", fillColor: [213, 229, 252] },
  //         },
  //         {
  //           content: "Resolved",
  //           colSpan: 3,
  //           styles: { halign: "center", valign: "middle", fontStyle: "bold", fillColor: [213, 229, 252] },
  //         },
  //         {
  //           content: "THT",
  //           rowSpan: 2,
  //           styles: { halign: "center", valign: "middle", fontStyle: "bold" },
  //         },
  //         {
  //           content: "OPI",
  //           rowSpan: 2,
  //           styles: { halign: "center", valign: "middle", fontStyle: "bold" },
  //         },
  //       ],
  //       [
  //         // Second row - sub-headers
  //         {
  //           content: "Total",
  //           styles: { halign: "center", fontStyle: "bold", fillColor: [238, 239, 240] },
  //         },
  //         {
  //           content: "Within Time",
  //           styles: { halign: "center", fontStyle: "bold", fillColor: [238, 239, 240] },
  //         },
  //         {
  //           content: "Late",
  //           styles: { halign: "center", fontStyle: "bold", fillColor: [238, 239, 240] },
  //         },
  //         {
  //           content: "Total",
  //           styles: { halign: "center", fontStyle: "bold", fillColor: [238, 239, 240] },
  //         },
  //         {
  //           content: "Within Time",
  //           styles: { halign: "center", fontStyle: "bold", fillColor: [238, 239, 240] },
  //         },
  //         {
  //           content: "Late",
  //           styles: { halign: "center", fontStyle: "bold", fillColor: [238, 239, 240] },
  //         },
  //       ],
  //     ];

  //     let bodyData = [];
  //     if (tableData?.length > 0) {
  //       bodyData = getFilteredAndSortedData().map((item, index) => {
  //         const inProgressWithinTime = 
  //           typeof item.totalInProgress === "number" &&
  //           typeof item.totalLateInProgress === "number"
  //             ? item.totalInProgress - item.totalLateInProgress
  //             : "-";

  //         const resolvedWithinTime = 
  //           typeof item.totalResolved === "number" &&
  //           typeof item.totalLateResolved === "number"
  //             ? item.totalResolved - item.totalLateResolved
  //             : "-";

  //         return [
  //           { content: index + 1, styles: { halign: "center" } },
  //           {
  //             content: item.subdivisionName
  //               ? `${item.subdivisionName}${item.subdivisionCode ? ` (${item.subdivisionCode})` : ""}`
  //               : "-",
  //             styles: { halign: "left" },
  //           },
  //           { content: item.name || "-", styles: { halign: "left" } },
  //           { content: item.fieldStaffId || "-", styles: { halign: "center" } },
  //           { content: item.roleName || "-", styles: { halign: "center" } },
  //           { content: item.totalComplaints || "-", styles: { halign: "center" } },
  //           // In Progress section
  //           { content: item.totalInProgress || "-", styles: { halign: "center" } },
  //           { content: inProgressWithinTime, styles: { halign: "center" } },
  //           { content: item.totalLateInProgress || "-", styles: { halign: "center" } },
  //           // Resolved section
  //           { content: item.totalResolved || "-", styles: { halign: "center" } },
  //           { content: resolvedWithinTime, styles: { halign: "center" } },
  //           { content: item.totalLateResolved || "-", styles: { halign: "center" } },
  //           // THT and OPI
  //           {
  //             content: item.totalHandlingTime
  //               ? convertSecondsToReadableTime(item.totalHandlingTime)
  //               : "-",
  //             styles: { halign: "center" },
  //           },
  //           {
  //             content: item.OPI ? Number(item.OPI).toFixed(2) : "-",
  //             styles: { halign: "center", fontStyle: "bold" },
  //           },
  //         ];
  //       });
  //     } else {
  //       bodyData.push([
  //         {
  //           content: "No Data Found",
  //           colSpan: 14,
  //           styles: {
  //             halign: "center",
  //             fontSize: 12,
  //             fontStyle: "bold",
  //             textColor: [255, 0, 0],
  //           },
  //         },
  //       ]);
  //     }

  //     pdf.autoTable({
  //       startY: 28,
  //       head: headers,
  //       body: bodyData,
  //       styles: { 
  //         cellPadding: 2, 
  //         fontSize: 7,
  //         halign: "center",
  //         lineColor: [255, 255, 255],
  //         lineWidth: 0.5,
  //       },
  //       headStyles: {
  //         fillColor: [213, 229, 252],
  //         textColor: [0, 0, 0],
  //         fontSize: 8,
  //         fontStyle: "bold",
  //       },
  //       alternateRowStyles: {
  //         fillColor: [227, 239, 255],
  //       },
  //       theme: "grid",
  //       tableWidth: pageWidth - 30,
  //       margin: { left: 15, right: 15 },
  //     });

  //     const totalPages = pdf.internal.getNumberOfPages();
  //     for (let i = 1; i <= totalPages; i++) {
  //       pdf.setPage(i);
  //       const pageNumberText = `Page ${i} of ${totalPages}`;
  //       pdf.setFontSize(10);
  //       pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
  //     }

  //    const filename =
  //     dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
  //       ? `Top ${sortOrder === "asc" ? "Best" : "Worst"} Performer${sortPart} - ${officeName} - ${convertDate(dateFrom)}.pdf`
  //       : `Top ${sortOrder === "asc" ? "Best" : "Worst"} Performer${sortPart} - ${officeName} - ${convertDate(dateFrom)}-to-${convertDate(dateTo)}.pdf`;
  //     if (print) {
  //       pdf.save(filename);
  //       resolve(pdf);
  //     } else {
  //       resolve(pdf);
  //     }
  //   });
  // };

  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = subdivisionName(parseInt(code), subDivisions);
      let dateToPrint = convertDate(new Date());
      let stampData = printStamp(code, offName, name, roleName, dateToPrint);
      const title = `Top ${sortOrder === "asc" ? "Worst" : "Best"} Performer${sortPart} Field Staff Report for ${officeName} – ${convertDate(dateFrom)}`;

      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth = ["12", "13", "11", "16", "27", "48", "59"].includes(
        companyCode,
      )
        ? 25
        : 30;
      const logoHeight = ["12", "13", "11", "16", "27", "48", "59"].includes(
        companyCode,
      )
        ? 20
        : 10;
      pdf.addImage(
        getLogo(code.slice(0, 2)),
        "PNG",
        15,
        5,
        logoWidth,
        logoHeight,
      );

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition = [
        "12",
        "13",
        "11",
        "16",
        "27",
        "48",
        "59",
      ].includes(companyCode)
        ? 43
        : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        ["12", "13", "11", "16", "27", "48", "59"].includes(companyCode)
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight,
      );

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(
        `Top ${sortOrder == "asc" ? "Worst" : "Best"
        } Performer Field Staff Report for ${officeName}`,
        pageWidth / 2,
        18,
        { align: "center" },
      );
      pdf.setFontSize(10);
      pdf.text(title, pageWidth / 2, 25, { align: "center" });
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      const headers = [
        [
          {
            content: "Sr#",
            rowSpan: 2,
            styles: { halign: "center", valign: "middle", fontStyle: "bold" },
          },
          {
            content: "Subdivision",
            rowSpan: 2,
            styles: { halign: "center", valign: "middle", fontStyle: "bold" },
          },
          {
            content: "Employee",
            rowSpan: 2,
            styles: { halign: "center", valign: "middle", fontStyle: "bold" },
          },
          {
            content: "User ID",
            rowSpan: 2,
            styles: { halign: "center", valign: "middle", fontStyle: "bold" },
          },
          {
            content: "Role",
            rowSpan: 2,
            styles: { halign: "center", valign: "middle", fontStyle: "bold" },
          },
          {
            content: "Total Complaints",
            rowSpan: 2,
            styles: { halign: "center", valign: "middle", fontStyle: "bold" },
          },
          {
            content: "In Progress",
            colSpan: 3,
            styles: { halign: "center", valign: "middle", fontStyle: "bold", fillColor: [213, 229, 252] },
          },
          {
            content: "Resolved",
            colSpan: 3,
            styles: { halign: "center", valign: "middle", fontStyle: "bold", fillColor: [213, 229, 252] },
          },
          {
            content: "AHT",
            rowSpan: 2,
            styles: { halign: "center", valign: "middle", fontStyle: "bold" },
          },
          {
            content: "OPI",
            rowSpan: 2,
            styles: { halign: "center", valign: "middle", fontStyle: "bold" },
          },
        ],
        [
          {
            content: "Total",
            styles: { halign: "center", fontStyle: "bold", fillColor: [238, 239, 240] },
          },
          {
            content: "Within Time",
            styles: { halign: "center", fontStyle: "bold", fillColor: [238, 239, 240] },
          },
          {
            content: "Late",
            styles: { halign: "center", fontStyle: "bold", fillColor: [238, 239, 240] },
          },
          {
            content: "Total",
            styles: { halign: "center", fontStyle: "bold", fillColor: [238, 239, 240] },
          },
          {
            content: "Within Time",
            styles: { halign: "center", fontStyle: "bold", fillColor: [238, 239, 240] },
          },
          {
            content: "Late",
            styles: { halign: "center", fontStyle: "bold", fillColor: [238, 239, 240] },
          },
        ],
      ];

      let bodyData = [];
      if (tableData?.length > 0) {
        const filteredData = getFilteredAndSortedData();
        const totalRows = filteredData.length;

        bodyData = filteredData.map((item, index) => {
          const inProgressWithinTime =
            typeof item.totalInProgress === "number" &&
              typeof item.totalLateInProgress === "number"
              ? item.totalInProgress - item.totalLateInProgress
              : "-";

          const resolvedWithinTime =
            typeof item.totalResolved === "number" &&
              typeof item.totalLateResolved === "number"
              ? item.totalResolved - item.totalLateResolved
              : "-";


          let fillColor = [227, 239, 255];
          let textColor = [64, 64, 64];

          if (sortField === "OPI") {
            if (sortOrder === "desc" && index < Math.min(5, totalRows)) {
              fillColor = [37, 146, 37];
              textColor = [255, 255, 255];
            } else if (sortOrder === "asc" && index < Math.min(5, totalRows)) {
              fillColor = [187, 21, 21];
              textColor = [255, 255, 255];
            }
          }

          return [
            { content: index + 1, styles: { halign: "center", fillColor, textColor } },
            {
              content: item.subdivisionName
                ? `${item.subdivisionName}${item.subdivisionCode ? ` (${item.subdivisionCode})` : ""}`
                : "-",
              styles: { halign: "left", fillColor, textColor },
            },
            { content: item.name || "-", styles: { halign: "left", fillColor, textColor } },
            { content: item.fieldStaffId || "-", styles: { halign: "center", fillColor, textColor } },
            { content: item.roleName || "-", styles: { halign: "center", fillColor, textColor } },
            { content: item.totalComplaints || "-", styles: { halign: "center", fillColor, textColor } },

            { content: item.totalInProgress || "-", styles: { halign: "center", fillColor, textColor } },
            { content: inProgressWithinTime, styles: { halign: "center", fillColor, textColor } },
            { content: item.totalLateInProgress || "-", styles: { halign: "center", fillColor, textColor } },

            { content: item.totalResolved || "-", styles: { halign: "center", fillColor, textColor } },
            { content: resolvedWithinTime, styles: { halign: "center", fillColor, textColor } },
            { content: item.totalLateResolved || "-", styles: { halign: "center", fillColor, textColor } },

            {
              content: item.avgHandlingTime
                ? convertSecondsToReadableTime(item.avgHandlingTime)
                : "-",
              styles: { halign: "center", fillColor, textColor },
            },

            {
              content: item.OPI ? Number(item.OPI).toFixed(2) : "-",
              styles: { halign: "center", fontStyle: "bold", fillColor, textColor },
            },
          ];
        });
      } else {
        bodyData.push([
          {
            content: "No Data Found",
            colSpan: 14,
            styles: {
              halign: "center",
              fontSize: 12,
              fontStyle: "bold",
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      pdf.autoTable({
        startY: 28,
        head: headers,
        body: bodyData,
        styles: {
          cellPadding: 2,
          fontSize: 7,
          halign: "center",
          lineColor: [255, 255, 255],
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [213, 229, 252],
          textColor: [0, 0, 0],
          fontSize: 8,
          fontStyle: "bold",
        },
        theme: "grid",
        tableWidth: pageWidth - 30,
        margin: { left: 15, right: 15 },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      const filename = `Top ${sortOrder === "asc" ? "Worst" : "Best"} Performer${sortPart} - ${officeName} - ${convertDate(dateFrom)}.pdf`;

      if (print) {
        pdf.save(filename);
        resolve(pdf);
      } else {
        resolve(pdf);
      }
    });
  };
  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const handleChangeDesgination = (e) => {
    console.log(e.target.value, "e.target.value");
    setDesginationCodeToApi(e.target.value);
  };

  const subdivisionName = (subdivisionCode, subDivisions) => {
    if (!subdivisionCode || !subDivisions || subDivisions.length === 0) {
      return "---";
    }

    const subdivision = subDivisions.find(
      (sub) =>
        parseInt(sub.code) === parseInt(subdivisionCode) ||
        sub.subdivisionCode === subdivisionCode ||
        sub.subDivisionCode === subdivisionCode,
    );

    return (
      subdivision?.name ||
      subdivision?.subdivisionName ||
      subdivision?.subDivisionName ||
      "---"
    );
  };

  const convertSecondsToReadableTime = (totalSeconds) => {
    if (
      totalSeconds === null ||
      totalSeconds === undefined ||
      isNaN(totalSeconds)
    ) {
      return "---";
    }

    let seconds = parseInt(totalSeconds, 10);

    const days = Math.floor(seconds / (24 * 3600));
    seconds %= 24 * 3600;

    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;

    const minutes = Math.floor(seconds / 60);
    seconds %= 60;

    let result = "";
    if (days > 0) result += `${days}d `;
    if (hours > 0) result += `${hours}h `;
    if (minutes > 0) result += `${minutes}m `;
    if (seconds > 0 || result === "") result += `${seconds}s`;

    return result.trim();
  };

  // Replace this static array:
  const sortFieldOptions = [
    { value: "totalResolved", label: "Total Resolved" },
    { value: "totalComplaints", label: "Total Complaints" },
    { value: "OPI", label: "OPI" }, // ← add this
    { value: "avgTimeTakenPending", label: "MPT" },
    { value: "avgTimeTakenAllocation", label: "MAT" },
    { value: "avgTimeTakenOnhold", label: "MHT" },
    { value: "avgTimeTakenWorking", label: "MWT" },
    { value: "avgTimeTakenResolved", label: "MRT" },
    { value: "totalHandlingTime", label: "THT" },
  ];

  const getSortFieldOptions = () => {
    const allOptions = [
      { value: "totalComplaints", label: "Total Complaints" },
      { value: "totalInProgress", label: "Total In Progress" },
      { value: "totalResolved", label: "Total Resolved" },
      { value: "avgHandlingTime", label: "Average Handling Time" },
      { value: "OPI", label: "OPI" },
    ];

    // Remove MPT & MAT when TAC is excluded
    // if (excludedRoles.includes("TAC")) {
    //   return allOptions.filter(
    //     (opt) =>
    //       opt.value !== "avgTimeTakenPending" &&
    //       opt.value !== "avgTimeTakenAllocation",
    //   );
    // }

    return allOptions;
  };

  const currentFilters = {
    officeCode,
    dateFrom,
    dateTo,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [officeCode, dateFrom, dateTo]);

  const handleGoClick = () => {
    getStats(officeCode, dateFrom, dateTo);

    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
  };


  const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  const getSortFieldLabel = (field) => {
    if (!field) return null; // ← important: return null when empty/default

    const options = {
      totalComplaints: "Total Complaints",
      totalInProgress: "Total In Progress",
      totalResolved: "Total Resolved",
      totalHandlingTime: "THT",
      OPI: "OPI",
      // add more if needed later
    };

    return options[field] || field;
  };

  const sortLabel = getSortFieldLabel(sortField);
  const sortPart = sortLabel ? ` (${sortLabel})` : "";

  const handleOPIClick = (event) => {
    setAnchorElOPI(event.currentTarget);
  };

  const handleThtClick = (event) => {
    setAnchorElTHT(event.currentTarget);
  };
  const handleThtClose = () => {
    setAnchorElTHT(null);
  };
  const handleOPIClose = () => {
    setAnchorElOPI(null);
  };

  const opiOpen = Boolean(anchorElOPI);
  const thtOpen = Boolean(anchorElTHT);
  return (
    <>
      <Box className="form-box">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Box className="application-table" style={{ marginRight: "10px" }}>
            <h3 style={{ color: "#006ad1", marginBottom: "10px" }}>
              Top {sortOrder == "asc" ? "Worst" : "Best"} Performer Field Staff
            </h3>
            <div className="div-datagrid">
              <div className="reports-container">
                <div
                  className="filter-fields"
                  style={{
                    width: "75%",
                    justifyContent: "flex-start",
                    gap: "15px",
                  }}
                >
                  <div className="field-container">
                    <Typography className="field-label">Month</Typography>
                    <input
                      type="month"
                      className="date-field"
                      value={dateFrom ? dateFrom.slice(0, 7) : ""}
                      onChange={(e) => {
                        const month = e.target.value;
                        setDateFrom(`${month}-01`);
                        setTableData([]);
                        setTotals({});
                      }}
                    />
                  </div>

                  {/* <div className="field-container">
                    <Typography className="field-label">Month To</Typography>
                    <input
                      type="month"
                      className="date-field"
                      value={dateTo ? dateTo.slice(0, 7) : ""}
                      max={new Date().toISOString().slice(0, 7)}
                      onChange={(e) => {
                        const month = e.target.value;
                        setDateTo(`${month}-01`);
                        setTableData([]);
                        setTotals({});
                      }}
                    />
                  </div> */}

                  {code == 10 && (
                    <div className="field-container">
                      <Typography className="field-label">Company</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedCompanyCode}
                        onChange={handleChangeCompany}
                      >
                        <option value="10">Select Company</option>
                        <option value="11">LESCO</option>
                        <option value="12">GEPCO</option>
                        <option value="13">FESCO</option>
                        <option value="14">IESCO</option>
                        <option value="15">MEPCO</option>
                        <option value="26">PESCO</option>
                        <option value="27">HAZECO</option>
                        <option value="37">HESCO</option>
                        <option value="38">SEPCO</option>
                        <option value="48">QESCO</option>
                        <option value="59">TESCO</option>
                      </select>
                    </div>
                  )}

                  {hierarchy <= 2 && (
                    <div className="field-container">
                      <Typography className="field-label">Circle</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={circleCode || ""}
                        onChange={handleCircleChange}
                      >
                        <option value="">All Circle</option>
                        {filteredCircles.map((circle) => (
                          <option
                            key={circle.circleCode}
                            value={circle.circleCode}
                          >
                            {circle.circleName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 3 && (
                    <div className="field-container">
                      <Typography className="field-label">Division</Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedDivision || ""}
                        onChange={handleDivisionChange}
                        disabled={!circleCode}
                      >
                        <option value="">All Division</option>
                        {filteredDivisions.map((division) => (
                          <option
                            key={division.divisionCode}
                            value={division.divisionCode}
                          >
                            {division.divisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {hierarchy <= 4 && (
                    <div className="field-container">
                      <Typography className="field-label">
                        Sub-Division
                      </Typography>
                      <select
                        className="dropdown-field"
                        style={{ backgroundColor: "white" }}
                        value={selectedSubDivision || ""}
                        onChange={handleSubDivisionChange}
                        disabled={!selectedDivision}
                      >
                        <option value="">All Sub-Division</option>
                        {filteredSubDivisions.map((subDivision) => (
                          <option
                            key={subDivision.subDivisionCode}
                            value={subDivision.subDivisionCode}
                          >
                            {subDivision.subDivisionName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginTop: "10px" }}
                    onClick={handleGoClick}
                    disabled={isGoDisabled || isLoading}
                  >
                    Go
                  </Button>
                </div>

                <div className="export-button-container">
                  {uniqueRoles?.length > 0 && (
                    <div className="field-container">
                      <div
                        style={{
                          display: "flex",
                          marginTop: 20,
                          flexDirection: "column",
                        }}
                      >
                        <Typography className="field-label">
                          Exclude Roles
                        </Typography>
                        <FormControl fullWidth>
                          <Select
                            multiple
                            value={excludedRoles}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              if (newValue.length === uniqueRoles.length) {
                                alert(
                                  "You cannot exclude all roles. At least one role must remain visible.",
                                );
                                return;
                              }
                              setExcludedRoles(newValue);
                            }}
                            displayEmpty
                            style={{
                              backgroundColor: "white",
                              height: 30,
                              width: 250,
                            }}
                            renderValue={(selected) => {
                              if (selected.length === 0) {
                                return (
                                  <span style={{ color: "#999" }}>
                                    No Role Excluded
                                  </span>
                                );
                              }
                              return selected.join(", ");
                            }}
                            MenuProps={{
                              PaperProps: { style: { width: 300 } },
                            }}
                          >
                            {uniqueRoles.map((role) => (
                              <MenuItem key={role} value={role}>
                                <Checkbox
                                  checked={excludedRoles.includes(role)}
                                />
                                <ListItemText primary={role} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                  )}
                  {
                    getSortFieldOptions().length > 0 && (
                      <div style={{ marginLeft: "15px" }}>
                        <Typography className="field-label">Sort By</Typography>
                        <select
                          className="dropdown-field"
                          style={{
                            backgroundColor: "white",
                            padding: "5px 10px",
                            border: "1px solid lightgray",
                            borderRadius: "5px",
                            width: "150px",
                          }}
                          value={sortField}
                          onChange={(e) => setSortField(e.target.value)}
                        >
                          <option value="">Select Sort Field</option>
                          {getSortFieldOptions().map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    )
                  }


                  <div style={{ marginLeft: "15px" }}>
                    <Typography className="field-label">Sort Order</Typography>
                    <select
                      className="dropdown-field"
                      style={{
                        backgroundColor: "white",
                        padding: "5px 10px",
                        border: "1px solid lightgray",
                        borderRadius: "5px",
                        width: "150px",
                      }}
                      value={sortOrder}
                      onChange={(e) => setSortOrder(e.target.value)}
                    >
                      <option value="desc">High → Low</option>
                      <option value="asc">Low → High</option>
                    </select>
                  </div>
                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      DownloadPdf(true);
                    }}
                    style={{ height: "40px", marginLeft: "15px" }}
                  >
                    <img
                      src={pdf}
                      alt="pdf"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      exportToExcel();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={excel}
                      alt="Excel"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>

                  <div
                    onClick={() => {
                      if (tableData.length === 0) {
                        noDataAvailable();
                        return;
                      }
                      printPDF();
                    }}
                    style={{ height: "40px" }}
                  >
                    <img
                      src={print}
                      alt="print"
                      style={{ ...internalIconStyles, height: "100%" }}
                    />
                  </div>
                </div>
              </div>
              <div className="table-container" style={{ marginBottom: "40px" }}>
                <div id="pdf-table">
                  <div
                    style={{
                      maxHeight: "900px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <table
                      className="table"
                      ref={tableRef}
                      style={{
                        marginBottom: "40px",
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "white",
                          zIndex: 10,
                        }}
                      >
                        {/* Title Row */}
                        <tr>
                          <th
                            colSpan={14} // adjust if you uncomment more columns later
                            style={{
                              fontSize: "20px",
                              borderBottom: "2px solid white",
                              textAlign: "center",
                              backgroundColor: "#d5e5fc",
                              color: "black",
                              padding: "12px",
                              fontFamily: "Roboto-Medium",
                            }}
                          >
                            {`Top ${sortOrder === "asc" ? "Worst" : "Best"} Performer${sortPart} Field Staff Report for ${officeName} – ${convertDate(dateFrom)}`}
                          </th>
                        </tr>

                        {/* Main Headers - two rows */}
                        <tr>
                          <th
                            rowSpan={2}
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#d5e5fc",
                              color: "black",
                              padding: "10px",
                              fontSize: "17px",
                              fontFamily: "Roboto-Medium",
                              minWidth: "30px",
                            }}
                          >
                            Sr#
                          </th>
                          <th
                            rowSpan={2}
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#d5e5fc",
                              color: "black",
                              padding: "10px",
                              fontSize: "17px",
                              fontFamily: "Roboto-Medium",
                              minWidth: "18px",
                            }}
                          >
                            Subdivision
                          </th>
                          <th
                            rowSpan={2}
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#d5e5fc",
                              color: "black",
                              padding: "10px",
                              fontSize: "17px",
                              fontFamily: "Roboto-Medium",
                              minWidth: "150px",
                            }}
                          >
                            Employee
                          </th>
                          <th
                            rowSpan={2}
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#d5e5fc",
                              color: "black",
                              padding: "10px",
                              fontSize: "17px",
                              fontFamily: "Roboto-Medium",
                              minWidth: "100px",
                            }}
                          >
                            User ID
                          </th>
                          <th
                            rowSpan={2}
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#d5e5fc",
                              color: "black",
                              padding: "10px",
                              fontSize: "17px",
                              fontFamily: "Roboto-Medium",
                              minWidth: "120px",
                            }}
                          >
                            Role
                          </th>
                          <th
                            rowSpan={2}
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#d5e5fc",
                              color: "black",
                              padding: "10px",
                              fontSize: "17px",
                              fontFamily: "Roboto-Medium",
                              minWidth: "120px",
                            }}
                          >
                            Total Complaints
                          </th>


                          {/* Complaints Section */}
                          <th
                            colSpan={3}
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#d5e5fc",
                              color: "black",
                              padding: "10px 20px",
                              fontSize: "18px",
                              fontFamily: "Roboto-Medium",
                            }}
                          >
                            In Progress
                          </th>

                          {/* Resolution Time Section */}
                          <th
                            colSpan={3}
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#d5e5fc",
                              color: "black",
                              padding: "10px 20px",
                              fontSize: "18px",
                              fontFamily: "Roboto-Medium",
                            }}
                          >
                            Resolved
                          </th>
                          <th
                            rowSpan={2}
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#d5e5fc",
                              color: "black",
                              padding: "10px",
                              fontSize: "17px",
                              fontFamily: "Roboto-Medium",
                              minWidth: "120px",
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", fontWeight: "bold" }}>
                            Average Handling Time
                              <IconButton
                                size="small"
                                onClick={handleThtClick}
                                sx={{ color: "#555", padding: "4px" }}
                              >
                                <InfoOutlinedIcon fontSize="small" />
                              </IconButton>
                            </div>

                            <Popover
                              open={thtOpen}
                              anchorEl={anchorElTHT}
                              onClose={handleThtClose}
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                              }}
                              transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                              }}
                            >
                              <Box sx={{ p: 2.5, maxWidth: 350 }}>
                                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                  Average Handling Time (AHT)
                                </Typography>

                                <Typography variant="body2" sx={{ mt: 2, lineHeight: 1.8 }}>
                                  {/* Average time from complaint registration to resolution/closing time. */}
                                  Average time taken to resolve a complaint from registration to closure
                                </Typography>
                              </Box>
                            </Popover>
                          </th>
                          <th
                            rowSpan={2}
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#d5e5fc",
                              color: "black",
                              padding: "10px",
                              fontSize: "17px",
                              fontFamily: "Roboto-Medium",
                              minWidth: "100px",
                              position: "relative",           // ← helps with positioning
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", fontWeight: "bold" }}>
                              OPI
                              <IconButton
                                size="small"
                                onClick={handleOPIClick}
                                sx={{ color: "#555", padding: "4px" }}
                              >
                                <InfoOutlinedIcon fontSize="small" />
                              </IconButton>
                            </div>

                            <Popover
                              open={opiOpen}
                              anchorEl={anchorElOPI}
                              onClose={handleOPIClose}
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                              }}
                              transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                              }}
                            >
                              <Box sx={{ p: 2.5, maxWidth: 460 }}>
                                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                  Optimum Performance Indicator (OPI<sup>v2</sup>)
                                </Typography>

                                <Typography variant="body2" sx={{ mt: 1, fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
                                  OPIᵛ² = 0.30R + 0.25(1−L) + 0.15(1/Tᵣⁿᵒʳᵐ) + 0.15(1/Tₕⁿᵒʳᵐ) + 0.15V
                                </Typography>

                                <Typography variant="body2" sx={{ mt: 2, lineHeight: 1.6 }}>
                                  <strong>Where:</strong><br />
                                  • R = Resolved %<br />
                                  • L = Late Resolved %<br />
                                  • Tᵣ = Mean Resolution Time<br />
                                  • Tₕ = Total Handling Time<br />
                                  • V = Log-normalized Total Complaints volume
                                </Typography>

                                {/* Optional image – uncomment if you have one */}
                                {/* <img 
        src="/path/to/opi-formula-diagram.png" 
        alt="OPI v2 Formula" 
        style={{ marginTop: 16, maxWidth: "100%", borderRadius: 6 }}
      /> */}
                              </Box>
                            </Popover>
                          </th>
                        </tr>

                        <tr>
                          {/* Sub-headers under Complaints */}
                          <th
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#eeeff0",
                              color: "black",
                              fontSize: "15px",
                              padding: "6px",
                              textAlign: "center",
                            }}
                          >
                            Total
                          </th>
                          <th
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#eeeff0",
                              color: "black",
                              fontSize: "15px",
                              padding: "6px",
                              textAlign: "center",
                            }}
                          >
                            Within Time
                          </th>
                          <th
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#eeeff0",
                              color: "black",
                              fontSize: "15px",
                              padding: "6px",
                              textAlign: "center",
                            }}
                          >
                            Late
                          </th>

                          {/* Sub-headers under Avg. Resolution Time (you can expand later) */}
                          <th
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#eeeff0",
                              color: "black",
                              fontSize: "15px",
                              padding: "6px",
                              textAlign: "center",
                            }}
                          >
                            Total
                          </th>
                          <th
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#eeeff0",
                              color: "black",
                              fontSize: "15px",
                              padding: "6px",
                              textAlign: "center",
                            }}
                          >
                            {/* You can split further if needed (e.g. Pending / Onhold / Working) */}
                            Within Time
                          </th>
                          <th
                            style={{
                              border: "6px solid white",
                              backgroundColor: "#eeeff0",
                              color: "black",
                              fontSize: "15px",
                              padding: "6px",
                              textAlign: "center",
                            }}
                          >
                            {/* Placeholder - can be Late or another metric */}
                            Late
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {viewBackdrop ? (
                          <tr>
                            <td colSpan={14} style={{ textAlign: "center", padding: "30px" }}>
                              <Box display="flex" justifyContent="center" alignItems="center">
                                <CircularProgress />
                              </Box>
                            </td>
                          </tr>
                        ) : tableData.length === 0 ? (
                          <tr>
                            <td
                              colSpan={14}
                              style={{
                                textAlign: "center",
                                padding: "15px",
                                fontWeight: "bold",
                                color: "red",
                                fontSize: "16px",
                              }}
                            >
                              No Data Found
                            </td>
                          </tr>
                        ) : (
                          getFilteredAndSortedData().map((item, index) => {
                            const data = getFilteredAndSortedData();
                            const totalRows = data.length;

                            let bgColor = index % 2 === 0 ? "#f8f9fa" : "#e3efff";

                            const isSortingByOPI = sortField === "OPI";

                            if (isSortingByOPI) {
                              if (sortOrder === "desc" && index < Math.min(5, totalRows)) {
                                bgColor = "#70d170";
                              } else if (sortOrder === "asc" && index < Math.min(5, totalRows)) {
                                bgColor = "#f37272";
                              }
                            }
                            return (
                              <tr
                                key={index}
                                style={{
                                  backgroundColor: bgColor,
                                  borderBottom: "1px solid #ccc",
                                }}
                              >
                                <td style={{ textAlign: "center", padding: "8px" }}>{index + 1}</td>
                                <td style={{ textAlign: "left", padding: "8px 12px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                  {item.subdivisionName || "-"}
                                  {item.subdivisionCode ? ` (${item.subdivisionCode})` : ""}
                                </td>
                                <td style={{ textAlign: "left", padding: "8px 12px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                  {item.name || "-"}
                                </td>
                                <td style={{ textAlign: "center", padding: "8px" }}>{item.fieldStaffId || "-"}</td>
                                <td style={{ textAlign: "center", padding: "8px" }}>{item.roleName || "-"}</td>
                                <td style={{ textAlign: "center", padding: "8px" }}>{item.totalComplaints || "-"}</td>
                                <td style={{ textAlign: "center", padding: "8px" }}>{item.totalInProgress || "-"}</td>
                                <td style={{ textAlign: "center", padding: "8px" }}>
                                  {typeof item.totalInProgress === "number" && typeof item.totalLateInProgress === "number"
                                    ? item.totalInProgress - item.totalLateInProgress
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "center", padding: "8px" }}>{item.totalLateInProgress || "-"}</td>
                                <td style={{ textAlign: "center", padding: "8px" }}>{item.totalResolved || "-"}</td>
                                <td style={{ textAlign: "center", padding: "8px" }}>
                                  {typeof item.totalResolved === "number" && typeof item.totalLateResolved === "number"
                                    ? item.totalResolved - item.totalLateResolved
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "center", padding: "8px" }}>{item.totalLateResolved || "-"}</td>
                                <td style={{ textAlign: "center", padding: "8px" }}>
                                  {item.avgHandlingTime ? convertSecondsToReadableTime(item.avgHandlingTime) : "-"}
                                </td>
                                <td style={{ textAlign: "center", padding: "8px", fontWeight: "bold" }}>
                                  {item.OPI?.toFixed(2) ?? "-"}
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Box>
      {selectedRemarks && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          disableRestoreFocus
        >
          <div style={{ padding: "10px" }}>
            <Typography variant="h6" sx={{ fontSize: "17px" }}>
              Remarks :
            </Typography>
            <Typography sx={{ fontSize: "14px" }}>{selectedRemarks}</Typography>
          </div>
        </Popover>
      )}
      {/* <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
    </>
  );
};

export default TopBestAndWorstPerformer;
